import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { parseJWT } from '@repo/shared';
import { Link, useNavigate, useSearch } from '@tanstack/react-router';

import { Spinner } from '@/components/ui/spinner';
import { useAuth } from '@/providers/auth-provider';
import { AUTH_REDIRECT_KEY } from '@/routes/(auth)/consts';

const Callback = () => {
  const { token, error, success } = useSearch({ from: '/auth/callback' });
  const { login } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    if (error || !success) {
      setErrorMessage(error ?? t('auth.login.errors.authenticationFailed'));
      return;
    }

    if (!token) {
      setErrorMessage(t('auth.login.errors.noTokenReceived'));
      return;
    }

    try {
      const payload = parseJWT(token);
      login({ username: payload.username, access_token: token });

      const redirectUrl = sessionStorage.getItem(AUTH_REDIRECT_KEY);
      sessionStorage.removeItem(AUTH_REDIRECT_KEY);

      const targetUrl = redirectUrl
        ? decodeURIComponent(redirectUrl)
        : '/app/scenarios';

      navigate({ to: targetUrl }).catch(console.error);
    } catch {
      setErrorMessage(t('auth.login.errors.invalidToken'));
    }
  }, [token, error, success, login, navigate, t]);

  if (errorMessage) {
    return (
      <div className='flex flex-col items-center gap-4'>
        <p className='text-destructive'>
          {t('auth.login.error', { error: errorMessage })}
        </p>
        <Link
          to='/auth/login'
          className='text-primary underline'>
          {t('auth.login.backToLogin')}
        </Link>
      </div>
    );
  }

  return (
    <div>
      <Spinner />
    </div>
  );
};

export default Callback;
